import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import {
    AdminActionTypeDTO,
    CommunityAdminDTO,
    IListAdminAuditLogResponse,
    IListAdminAuditQuery,
} from "./types"

export const appendArray = (
    params: Record<string, string | number>,
    key: string,
    values?: string[]
): void => {
    if (values?.length) {
        params[key] = values.join(",")
    }
}

export const buildAdminAuditParams = (
    query: IListAdminAuditQuery
): Record<string, string | number> => {
    const params: Record<string, string | number> = {
        page: query.page,
        page_size: query.pageSize,
    }

    appendArray(params, "admin_ids", query.adminIds)
    appendArray(params, "action_types", query.actionTypes)
    if (query.periodFrom) params.period_from = query.periodFrom
    // Границу периода конвертирует сервер: для date-only значения
    // `normalizeAdminCompatiblePeriod` сам сдвигает конец на день вперёд
    // (полуинтервал `[from, to)`). Клиент отправляет ВЫБРАННУЮ дату как есть —
    // иначе день прибавился бы дважды, а выбранный 31-дневный период стал бы
    // 32-дневным и упёрся бы в серверный лимит выгрузки.
    if (query.periodTo) params.period_to = query.periodTo

    return params
}

export type JournalExportFormat = "csv" | "xlsx"

/**
 * Экспорт обязан использовать ровно те же фильтры, что и список: параметры
 * строятся из `buildAdminAuditParams`, а не собираются заново. Отличие ровно
 * два — экспорт не постраничный и несёт `format`.
 */
export const buildAdminAuditExportParams = (
    query: IListAdminAuditQuery,
    format: JournalExportFormat
): Record<string, string | number> => {
    const params = buildAdminAuditParams(query)

    delete params.page
    delete params.page_size
    params.format = format

    return params
}

export const exportAdminAuditLog = (
    query: IListAdminAuditQuery,
    format: JournalExportFormat
): Promise<AxiosResponse<Blob>> => {
    return apiInstance.handler.get<Blob>("/admin-audit-log/export", {
        params: buildAdminAuditExportParams(query, format),
        responseType: "blob",
    })
}

export const listAdminAuditLog = (
    query: IListAdminAuditQuery
): Promise<AxiosResponse<IListAdminAuditLogResponse>> => {
    return apiInstance.handler.get<IListAdminAuditLogResponse>("/admin-audit-log", {
        params: buildAdminAuditParams(query),
    })
}

export const getAdminAuditActionTypes = (): Promise<AxiosResponse<AdminActionTypeDTO[]>> => {
    return apiInstance.handler.get<AdminActionTypeDTO[]>("/admin-audit-log/action-types")
}

export const listCommunityAdmins = (): Promise<AxiosResponse<CommunityAdminDTO[]>> => {
    return apiInstance.handler.get<CommunityAdminDTO[]>("/admins")
}
